import {
    GetProdutosPainelImplantacaoService,
    GetProdutosPorUnidadeEquipeServices,
} from "../../../Services/Vendas/PainelImplantacao/PainelImplatancaoServices";
import { Controller } from "../../Controller";

export function GetProdutosPorUnidadeEquipeController(
    idEmpreendimento: number
) {
    return Controller(GetProdutosPorUnidadeEquipeServices(idEmpreendimento));
}

export function GetProdutosPainelImplantacaoController(
    idEmpreendimento: number
) {
    return Controller(GetProdutosPainelImplantacaoService(idEmpreendimento));
}
